import {dom, library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon, FontAwesomeLayers} from '@fortawesome/vue-fontawesome';
import {createApp, h} from 'vue';
import Storage from 'vue-web-storage';
import {createBootstrap} from 'bootstrap-vue-next/plugins/createBootstrap'

import 'maz-ui/styles';
import FlagIcon from 'vue-flag-icon';
import globalEnv from '@/globalEnv.js';
import App from './App.vue';
import fontAwesomeIcons from './constants/fontAwesomeIcons';
import router from './router';
import store from './store';
import {defineRule} from "vee-validate";
import {email, min, required} from "@vee-validate/rules";
import axios from 'axios';
import {MazUi} from 'maz-ui/plugins/maz-ui'

import {mazUi} from '@maz-ui/themes'
import {en} from '@maz-ui/translations/locales'
import {vBPopover, vBTooltip} from 'bootstrap-vue-next';

library.add(fontAwesomeIcons);

dom.watch();

const app = createApp({
  render: () => h(App),
});

app.directive('b-tooltip', vBTooltip);
app.directive('b-popover', vBPopover);

app.use(router);
app.use(store);

app.use(createBootstrap());
// app.use(filters);
app.use(Storage);
app.config.globalProperties.$http = axios;
app.use(FlagIcon);

app.use(MazUi, {
  theme: {
    preset: mazUi,
    mode: 'light',
    colorMode: 'light'
  },
  translations: {
    messages: {en},
  },
});


defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('confirmed', (value, [target]) => {
  if (!value || !target) return true;
  if (value !== target) {
    return 'Confirmed password does not match';
  }
  return true;
});

app.config.globalProperties.$globalEnv = globalEnv;

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('FontAwesomeLayers', FontAwesomeLayers);

// This callback runs before every route change, including on page load.
router.beforeEach((to, from) => {
  // 1. Handle document Title
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // 2. Clear old custom meta tags
  Array.from(document.querySelectorAll('[data-vue-router-controlled]'))
    .forEach((el) => el.parentNode.removeChild(el));

  // 3. Process new meta tags if they exist
  const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

  if (nearestWithMeta && nearestWithMeta.meta.metaTags) {
    nearestWithMeta.meta.metaTags.forEach((tagDef) => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      tag.setAttribute('data-vue-router-controlled', '');
      document.head.appendChild(tag);
    });
  }

  return true;
});

router.isReady().then(() => {
  app.mount('#app')
})
